import axios from 'axios';
const currentPageUrl = "https://hochhuth-consulting.de";
console.log(currentPageUrl)
const baseUrl = "https://hochhuth-consulting.de";

// Declared here so there is one place to switch. api/LiveSitePublic.php serves
// both actions; once it is deployed to /HHHHPUBLICAPI/, change these two to:
//   export const READ_URL    = `${baseUrl}/HHHHPUBLICAPI/LiveSitePublic.php`;
//   export const CONTACT_URL = READ_URL;
export const READ_URL = `${baseUrl}/HHHHPUBLICAPI/getDataAll.php`;
export const CONTACT_URL = `${baseUrl}/HHHHPUBLICAPI/insertForm.php`;

export const getPublicServerData = async (tableName) => {
    let results = [];
    try {
        const payload = {
            table: `${tableName}`
        };
        const response = await axios.post(READ_URL, payload, {
            headers: {
                "Content-Type": "application/json"
            }
        });
        results = response?.data?.data || [];
        return results;
    } catch (error) {
        console.error('An error occurred:', error);
        return [];
    }
}


